<template>
  <section>
    <span v-if="player.isAverageRating" class="player__status player__status--average">M</span>
    <span v-if="player.isLiveRating && ! player.isLiveSubstitute" class="player__status player__status--live" />
    <span v-if="player.isLiveRating && player.isLiveSubstitute" class="player__status player__status--live-substitute" />
    <span v-if="player.isLiveSubstitued" class="player__status player__status--live-substitued">
      <substitution-icon is-out />
    </span>
    <span v-if="player.isFinalSubstitute" class="player__status player__status--final-substitute">
      X
    </span>
  </section>
</template>

<script setup>
import SubstitutionIcon from "@/components/icons/SubstitutionIcon.vue";
import { Player } from "@/models/players/Player";

defineProps({
  player: {
    type: Player,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
.player__status {
  display: block;
  font-size: 0.6em;
  font-weight: bold;
  border-radius: 100%;
  width: 10px;
  height: 10px;
  line-height: 10px;
  text-align: center;
  padding: 0;

  &--average {
    background-color: var(--bs-yellow);
    color: #333;
    right: 0;
  }

  &--live {
    background-color: var(--bs-red);
    color: #fff;
    width: 7px;
    height: 7px;
    animation: blink 2s infinite;
  }

  &--live-substitued {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--bs-red);
    width: 15px;
    height: 15px;
    margin-right: -4px;
  }

  &--live-substitute {
    border: 1px solid var(--bs-red);
    color: #fff;
    width: 7px;
    height: 7px;
    animation: blink 2s infinite;
  }

  &--final-substitute {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--bs-red);
    color: var(--bs-red);
    width: 10px;
    height: 10px;
  }
}

@keyframes blink {
  0% { opacity: 0.5; }
  50% { opacity: 1; }
  100% { opacity: 0.5; }
}
</style>